module.exports = __webpack_public_path__ + "img/logo_v3.29b9ba72.png";